var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgGreenCheck = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 130,
    height: 130,
    viewBox: "0 0 130 130",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.4175 79.9366L95.9618 34.3632C97.0366 33.2877 98.2905 32.75 99.7235 32.75C101.157 32.75 102.411 33.2877 103.485 34.3632C104.56 35.4387 105.098 36.7158 105.098 38.1946C105.098 39.6734 104.56 40.9505 103.485 42.026L54.1793 91.498C53.1045 92.5735 51.8505 93.1112 50.4175 93.1112C48.9844 93.1112 47.7305 92.5735 46.6557 91.498L23.5477 68.3752C22.4729 67.2998 21.9579 66.0226 22.0027 64.5438C22.0475 63.0651 22.6073 61.7879 23.682 60.7124C24.7568 59.637 26.0332 59.0992 27.511 59.0992C28.9888 59.0992 30.2651 59.637 31.3399 60.7124L50.4175 79.9366Z",
    fill: "#2EC9B7"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgGreenCheck, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/green-check.da5ec434.svg";
export { ForwardRef as ReactComponent };